<div class="scrollable-section" #scrollableSection>
  <!-- Botón de cerrar en la esquina superior izquierda -->
  <button rel="tooltip" type="button" class="btn btn-action float-right close-button " (click)="closePopUp()">
    <i class="material-icons">close</i>
  </button>


  <div *ngIf="data && data.length > 0">

    <button [ngClass]="{ 'hide-scroll-button': !showScrollDown }" class="scroll-down-button" (click)="scrollDown()">
      <fa-icon icon="arrow-alt-circle-down"></fa-icon>
    </button>

    <app-generic-panel [title]="getTitle()" [description]="panelDescription" [icon]="panelIcon">



      <div class="button-container download">
        <button *ngIf="image" mat-raised-button class="download-button" (click)="downloadResource(image)">
          <fa-icon icon="download"></fa-icon> IMAGEN
        </button>
        <button *ngIf="a3Doc.associatedA3doc" [disabled]="!a3Doc.docData" mat-raised-button class="download-button"
          (click)="downloadResource(a3Doc, true)">
          <fa-icon icon="download"></fa-icon> DOCUMENTO
        </button>

        <div *ngIf="!innuvaPersonalRequest1 && !advanceRequest1 && data && data.length > 0 ">
          <button *ngIf="!isNew" class="btn btn-fill btn-primary float-right calendar-button" type="button"
            (click)="onOpenCalendar()">
            <fa-icon icon="calendar-alt" size="1x" class='mr-2 calendar-icon'></fa-icon>
            Calendario
          </button>
        </div>

      </div>

      <div class="justify-content-center m-auto d-flex w-100">
        <app-solicitud-timeline [date]="createdAt" [state]="stateValue" [stateDate]="validationDate"
          [hrState]="hrStateValue" [dualState]="dualStateValue" [hrDate]="validationHrDate"
          [dualDate]="dualValidationDate" [ngStyle]="{ 'width': '100%' }" [type]="typeName">
        </app-solicitud-timeline>
      </div>



      <div class="row" *ngIf="!innuvaPersonalRequest1 && !advanceRequest1">
        <div class="col-sm-12 col-lg-12 ">
          <div class="row justify-content-center">
            <div class="col-xl-6 ">
              <div class="block">
                <legend class="pl-0 mt-2">Datos de la Solicitud</legend>
                <app-form-input-app [labelText]="'Nombre completo'" [isRequired]="false">
                  <input class="form-control mb-1" autocomplete="off" type="text" name="Fullname" [(ngModel)]="fullName"
                    readonly>
                </app-form-input-app>

                <app-form-input-app [labelText]="'Empresa'" [isRequired]="false">
                  <input class="form-control mb-1" autocomplete="off" type="text" name="Company" [(ngModel)]="company"
                    readonly>
                </app-form-input-app>

                <app-form-input-app [labelText]="'Tipo'" [isRequired]="false">
                  <input class="form-control mb-1" autocomplete="off" type="text" name="type" [(ngModel)]="typeName"
                    readonly>
                </app-form-input-app>

              </div>
            </div>


            <div class="col-6 ">
              <div class="block">
                <legend class="pl-0 mt-2"> ‎ </legend> <!-- ‎  caracter invisible -->

                <app-form-input-app [labelText]="'Duración Inferior a un día'" [isRequired]="false">
                  <input class="form-control mb-1" autocomplete="off" type="text" name="type"
                    [(ngModel)]="lessThanOneDay" readonly>
                </app-form-input-app>

                <app-form-input-app [labelText]="'Fecha de inicio'" [isRequired]="false">
                  <input class="form-control mb-1" autocomplete="off" type="text" name="StartDate"
                    [(ngModel)]="startDate" readonly>
                </app-form-input-app>

                <app-form-input-app *ngIf="lessThanOneDay == 'No'" [labelText]="'Fecha de Fin'" [isRequired]="false">
                  <input class="form-control mb-1" autocomplete="off" type="text" name="EndDate" [(ngModel)]="endDate"
                    readonly>
                </app-form-input-app>

                <app-form-input-app *ngIf="lessThanOneDay == 'Sí'" [labelText]="'Duración'" [isRequired]="false">
                  <input class="form-control mb-1" autocomplete="off" type="text" name="Duration" [(ngModel)]="duration"
                    readonly>
                </app-form-input-app>

              </div>
            </div>
            <div class="col-12  mt-2">
              <app-form-input-app [labelText]="'Observaciones'" [isRequired]="false">
                <textarea rows="5" class="form-control" autocomplete="off" type="text" name="observations"
                  [(ngModel)]="observations" readonly></textarea>
              </app-form-input-app>
            </div>
          </div>
        </div>

        <div class="col-sm-12 col-lg-12 ">
          <div class="row justify-content-center">
            <div class="col-xl-6 ">
              <div class="block">
                <legend *ngIf="!advanceRequest1" class="pl-0 mt-4">Datos de Validación</legend>

                <app-form-input-app [labelText]="'Validador'" [isRequired]="false">
                  <input class="form-control mb-1" autocomplete="off" type="text" name="Validator"
                    [(ngModel)]="validator" readonly>
                </app-form-input-app>

                <app-form-input-app [labelText]="'Validador doble'" [isRequired]="false" *ngIf="dualValidator">
                  <input class="form-control mb-1" autocomplete="off" type="text" name="dualValidator"
                    [(ngModel)]="dualValidator" readonly>
                </app-form-input-app>

                <app-form-input-app [labelText]="'Validador RRHH'" [isRequired]="false">
                  <input class="form-control mb-1 text-ellipsis" autocomplete="off" type="text" name="HRValidator"
                    [(ngModel)]="hrValidators" readonly>
                </app-form-input-app>

              </div>
            </div>


            <div class="col-6 ">
              <div class="block">
                <legend class="pl-0 mt-4"> ‎ </legend> <!-- ‎  caracter invisible -->

                <app-form-input-app [labelText]="'Estado validación'" [isRequired]="false">
                  <input class="form-control mb-1" autocomplete="off" type="text" name="StateValue"
                    [(ngModel)]="stateValue" readonly>
                </app-form-input-app>

                <app-form-input-app [labelText]="'Estado validación doble'" [isRequired]="false" *ngIf="dualValidator">
                  <input class="form-control mb-1" autocomplete="off" type="text" name="DualStateValue"
                    [(ngModel)]="dualStateValue" readonly>
                </app-form-input-app>

                <app-form-input-app [labelText]="'Estado validación RRHH'" [isRequired]="false">
                  <input class="form-control mb-1" autocomplete="off" type="text" name="HRStateValue"
                    [(ngModel)]="hrStateValue" readonly>
                </app-form-input-app>

              </div>
            </div>

            <div *ngIf="(state == 0 || dualState == 0) && enabledValidator" class="col-12 mt-2">
              <label class="validate-check">

                <dx-check-box [(ngModel)]="isChecked" (onValueChanged)="updateIsChecked($event)"></dx-check-box>
                <span class="mt-1">
                  Validar en nombre de ({{ validator }}{{ dualValidator ? ' y ' + dualValidator : '' }})
                </span>

              </label>
            </div>


            <div class="col-6  mt-2">
              <legend class="pl-0 mt-4">Observaciones</legend>
              <app-form-input-app [labelText]="'Observaciones para el validador'" [isRequired]="false">
                <textarea rows="5" class="form-control" [(ngModel)]="observationsValidator" autocomplete="off"
                  type="text" name="observationsValidator"
                  [readOnly]="hrState != 0 || showAccepted || showRejected"></textarea>
              </app-form-input-app>
            </div>

            <div class="col-6  mt-2">
              <legend class="pl-0 mt-4"> ‎ </legend> <!-- ‎  caracter invisible -->
              <app-form-input-app [labelText]="'Observaciones para el empleado'" [isRequired]="false">

                <textarea rows="5" class="form-control" [(ngModel)]="observationsEmployee" autocomplete="off"
                  type="text" name="observationsEmployee" [readOnly]="showAccepted || showRejected"
                  *ngIf="hrState == 0"></textarea>

                <textarea rows="5" class="form-control" [(ngModel)]="observations" autocomplete="off" type="text"
                  name="observationsEmployee" [readOnly]="hrState != 0" *ngIf="hrState != 0"></textarea>

              </app-form-input-app>
            </div>

            <div *ngIf="hrState == 0 && state != 2" class="button-container accept-deny">

              <div *ngIf="showAccepted">
                <h4 ngClass="approved">APROBADA</h4>
              </div>
              <div *ngIf="showRejected">
                <h4 ngClass="denied">RECHAZADA</h4>
              </div>

              <div *ngIf="enabledValidator && !showAccepted && !showRejected && enabledValidator">
                <button mat-raised-button class="rechazar-button"
                  [class.disabled-button]="dualState !== undefined ? !(((state == 0 || dualState == 0) && isChecked) || (state != 0 && dualState != 0)) : !((state == 0 && isChecked) || (state != 0))"
                  (click)="(dualState !== undefined ? (((state == 0 || dualState == 0) && isChecked) || (state != 0 && dualState != 0)) : ((state == 0 && isChecked) || (state != 0))) && rejectRequest()">RECHAZAR</button>

                <button mat-raised-button class="aceptar-button"
                  [class.disabled-button]="dualState !== undefined ? !(((state == 0 || dualState == 0) && isChecked) || (state != 0 && dualState != 0)) : !((state == 0 && isChecked) || (state != 0))"
                  (click)="(dualState !== undefined ? (((state == 0 || dualState == 0) && isChecked) || (state != 0 && dualState != 0)) : ((state == 0 && isChecked) || (state != 0))) && acceptRequest()">APROBAR</button>
              </div>

            </div>
          </div>
        </div>
      </div>

      <!-- Si es una solicitud de Cambio de datos -->
      <div class="row" *ngIf="innuvaPersonalRequest1 || advanceRequest1">
        <div class="col-sm-12 col-lg-12 ">
          <div class="row justify-content-center">
            <div class="col-xl-6 ">
              <div class="block">
                <legend class="pl-0 mt-2">Datos de la Solicitud</legend>
                <app-form-input-app [labelText]="'Nueva cuenta bancaria'" [isRequired]="false"
                  *ngIf="innuvaBankAccount">
                  <input class="form-control mb-1" autocomplete="off" type="text" name="innuvaBankAccount"
                    [(ngModel)]="innuvaBankAccount" readonly>
                </app-form-input-app>

                <app-form-input-app [labelText]="'Fecha de cambio de cuenta bancaria'" [isRequired]="false"
                  *ngIf="innuvaBankAccount">
                  <input class="form-control mb-1" autocomplete="off" type="text" name="innuvaScheduledDate"
                    [(ngModel)]="innuvaScheduledDate" readonly>
                </app-form-input-app>

                <app-form-input-app [labelText]="'Nuevo correo electrónico'" [isRequired]="false" *ngIf="innuvaEmail">
                  <input class="form-control mb-1" autocomplete="off" type="text" name="innuvaEmail"
                    [(ngModel)]="innuvaEmail" readonly>
                </app-form-input-app>

                <app-form-input-app [labelText]="'Nuevo tipo de vía'" [isRequired]="false" *ngIf="innuvaAcronym">
                  <input class="form-control" autocomplete="off" type="text" [(ngModel)]="innuvaAcronym"
                    name="innuvaAcronym" readonly>
                </app-form-input-app>

                <app-form-input-app [labelText]="'Nuevo nombre de la vía'" [isRequired]="false"
                  *ngIf="innuvaStreetName">
                  <input class="form-control" autocomplete="off" type="text" [(ngModel)]="innuvaStreetName"
                    name="innuvaStreetName" readonly>
                </app-form-input-app>

                <app-form-input-app [labelText]="'Nuevo número'" [isRequired]="false" *ngIf="innuvaBuildingNumber">
                  <input class="form-control" autocomplete="off" type="text" [(ngModel)]="innuvaBuildingNumber"
                    name="innuvaBuildingNumber" readonly>
                </app-form-input-app>

                <app-form-input-app [labelText]="'Nueva escalera'" [isRequired]="false" *ngIf="innuvaStairwell">
                  <input class="form-control" autocomplete="off" type="text" [(ngModel)]="innuvaStairwell"
                    name="innuvaStairwell" readonly>
                </app-form-input-app>

                <app-form-input-app [labelText]="'Nuevo piso'" [isRequired]="false" *ngIf="innuvaFloor">
                  <input class="form-control" autocomplete="off" type="text" [(ngModel)]="innuvaFloor"
                    name="innuvaFloor" readonly>
                </app-form-input-app>

                <app-form-input-app [labelText]="'Nueva puerta'" [isRequired]="false" *ngIf="innuvaGate">
                  <input class="form-control" autocomplete="off" type="text" [(ngModel)]="innuvaGate" name="innuvaGate"
                    readonly>
                </app-form-input-app>

                <app-form-input-app [labelText]="'Nuevo país'" [isRequired]="false" *ngIf="innuvaCountryName">
                  <input class="form-control" autocomplete="off" type="text" [(ngModel)]="innuvaCountryName"
                    name="innuvaCountryName" readonly>
                </app-form-input-app>

                <app-form-input-app [labelText]="'Nuevo código postal'" [isRequired]="false" *ngIf="innuvaPostalCode">
                  <input class="form-control" autocomplete="off" type="text" [(ngModel)]="innuvaPostalCode"
                    name="innuvaPostalCode" readonly>
                </app-form-input-app>

                <app-form-input-app [labelText]="'Anticipo solicitado'" [isRequired]="false"
                  *ngIf="advanceRequestedAmount">
                  <input class="form-control" autocomplete="off" type="text" [(ngModel)]="advanceRequestedAmount"
                    name="advanceRequestedAmount" readonly>
                </app-form-input-app>


              </div>
            </div>


            <div class="col-6 ">
              <div class="block">
                <legend class="pl-0 mt-2"> ‎ </legend> <!-- ‎  caracter invisible -->

                <app-form-input-app [labelText]="'Anterior cuenta bancaria'" [isRequired]="false"
                  *ngIf="innuvaOldBankAccount">
                  <input class="form-control mb-1" autocomplete="off" type="text" name="innuvaOldBankAccount"
                    [(ngModel)]="innuvaOldBankAccount" readonly>
                </app-form-input-app>

                <app-form-input-app [labelText]="'Cambio de cuenta realizado'" [isRequired]="false"
                  *ngIf="innuvaBankAccount">
                  <input class="form-control mb-1" autocomplete="off" type="text" name="innuvaScheduledDone"
                    [(ngModel)]="innuvaScheduledDone" readonly>
                </app-form-input-app>

                <app-form-input-app [labelText]="'Anterior correo electrónico'" [isRequired]="false"
                  *ngIf="innuvaOldEmail">
                  <input class="form-control mb-1" autocomplete="off" type="text" name="innuvaOldEmail"
                    [(ngModel)]="innuvaOldEmail" readonly>
                </app-form-input-app>

                <app-form-input-app [labelText]="'Anterior tipo de vía'" [isRequired]="false" *ngIf="innuvaAcronym">
                  <input class="form-control" autocomplete="off" type="text" [(ngModel)]="innuvaOldAcronym"
                    name="innuvaOldAcronym" readonly>
                </app-form-input-app>

                <app-form-input-app [labelText]="'Anterior nombre de la vía'" [isRequired]="false"
                  *ngIf="innuvaStreetName">
                  <input class="form-control" autocomplete="off" type="text" [(ngModel)]="Old"
                    name="innuvaOldStreetName" readonly>
                </app-form-input-app>

                <app-form-input-app [labelText]="'Anterior número'" [isRequired]="false" *ngIf="innuvaBuildingNumber">
                  <input class="form-control" autocomplete="off" type="text" [(ngModel)]="innuvaOldBuildingNumber"
                    name="innuvaOldBuildingNumber" readonly>
                </app-form-input-app>

                <app-form-input-app [labelText]="'Anterior escalera'" [isRequired]="false" *ngIf="innuvaStairwell">
                  <input class="form-control" autocomplete="off" type="text" [(ngModel)]="innuvaOldStairwell"
                    name="innuvaOldStairwell" readonly>
                </app-form-input-app>

                <app-form-input-app [labelText]="'Anterior piso'" [isRequired]="false" *ngIf="innuvaFloor">
                  <input class="form-control" autocomplete="off" type="text" [(ngModel)]="innuvaOldFloor"
                    name="innuvaOldFloor" readonly>
                </app-form-input-app>

                <app-form-input-app [labelText]="'Nueva puerta'" [isRequired]="false" *ngIf="innuvaGate">
                  <input class="form-control" autocomplete="off" type="text" [(ngModel)]="innuvaOldGate"
                    name="innuvaOldGate" readonly>
                </app-form-input-app>

                <app-form-input-app [labelText]="'Anterior país'" [isRequired]="false" *ngIf="innuvaCountryName">
                  <input class="form-control" autocomplete="off" type="text" [(ngModel)]="innuvaOldCountryName"
                    name="innuvaOldCountryName" readonly>
                </app-form-input-app>

                <app-form-input-app [labelText]="'Anterior código postal'" [isRequired]="false"
                  *ngIf="innuvaPostalCode">
                  <input class="form-control" autocomplete="off" type="text" [(ngModel)]="innuvaOldPostalCode"
                    name="innuvaOldPostalCode" readonly>
                </app-form-input-app>

                <app-form-input-app [labelText]="'Anticipo restante'" [isRequired]="false" *ngIf="advanceCurrentAmount">
                  <input class="form-control" autocomplete="off" type="text" [(ngModel)]="advanceCurrentAmount"
                    name="advanceCurrentAmount" readonly>
                </app-form-input-app>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-12 col-lg-12 ">
          <div class="row justify-content-center">
            <div class="col-xl-6 ">
              <div class="block">
                <legend class="pl-0 mt-4">Datos de Validación</legend>

                <app-form-input-app *ngIf="innuvaPersonalRequest1" [labelText]="'Validador RRHH'" [isRequired]="false">
                  <input class="form-control mb-1 text-ellipsis" autocomplete="off" type="text" name="HRValidator"
                    [(ngModel)]="hrValidators" readonly>
                </app-form-input-app>

                <app-form-input-app *ngIf="advanceRequest1" [labelText]="'Validador anticipos'" [isRequired]="false">
                  <input class="form-control mb-1 text-ellipsis" autocomplete="off" type="text" name="advanceValidator"
                    [(ngModel)]="advanceValidator" readonly>
                </app-form-input-app>

              </div>
            </div>


            <div class="col-6 ">
              <div class="block">
                <legend class="pl-0 mt-4"> ‎ </legend> <!-- ‎  caracter invisible -->

                <app-form-input-app *ngIf="innuvaPersonalRequest1" [labelText]="'Estado RRHH'" [isRequired]="false">
                  <input class="form-control mb-1" autocomplete="off" type="text" name="HRStateValue"
                    [(ngModel)]="hrStateValue" readonly>
                </app-form-input-app>

                <app-form-input-app *ngIf="advanceRequest1" [labelText]="'Estado anticipos'" [isRequired]="false">
                  <input class="form-control mb-1" autocomplete="off" type="text" name="advanceState"
                    [(ngModel)]="advanceState" readonly>
                </app-form-input-app>

              </div>
            </div>


            <div class="col-6  mt-2" *ngIf="!advanceRequest1">
              <legend class="pl-0 mt-4"> ‎ </legend> <!-- ‎  caracter invisible -->
              <app-form-input-app [labelText]="'Observaciones para el empleado'" [isRequired]="false">

                <textarea rows="5" class="form-control" [(ngModel)]="observationsEmployee" autocomplete="off"
                  type="text" name="observationsEmployee" [readOnly]="showAccepted || showRejected"
                  *ngIf="hrState == 0"></textarea>

                <textarea rows="5" class="form-control" [(ngModel)]="observations" autocomplete="off" type="text"
                  name="observationsEmployee" [readOnly]="hrState != 0" *ngIf="hrState != 0"></textarea>

              </app-form-input-app>
            </div>

            <div *ngIf="hrState == 0 && state != 2" class="button-container accept-deny">

              <div *ngIf="showAccepted">
                <h4 ngClass="approved">APROBADA</h4>
              </div>
              <div *ngIf="showRejected">
                <h4 ngClass="denied">RECHAZADA</h4>
              </div>

              <div *ngIf="enabledValidator && !showAccepted && !showRejected && enabledValidator">
                <button mat-raised-button class="rechazar-button"
                  [class.disabled-button]="!((state == 0 && isChecked == true) || (state != 0))"
                  (click)="((state == 0 && isChecked == true) || (state != 0)) && rejectRequest()">RECHAZAR</button>

                <button mat-raised-button class="aceptar-button"
                  [class.disabled-button]="!((state == 0 && isChecked == true) || (state != 0))"
                  (click)="((state == 0 && isChecked == true) || (state != 0)) && acceptRequest()">APROBAR</button>
              </div>

            </div>
          </div>
        </div>
      </div>

    </app-generic-panel>

    <app-generic-panel *ngIf="holidayBag" [title]="getTitleHolidayReq()" [description]="panelDescription"
      [icon]="panelIcon">

      <div class="justify-content-center m-auto d-flex timeline-bag">
        <app-solicitud-timeline [date]="createdAt" [bagState]="holidayBagState.name" [bagStateDate]="validationBagDate"
          [ngStyle]="{ 'width': '100%' }" [type]="typeName">
        </app-solicitud-timeline>
      </div>

      <div class="row">
        <div class="col-sm-12 col-lg-12 ">
          <div class="row justify-content-center">
            <div class="col-xl-6 ">
              <div class="block">
                <app-form-input-app [labelText]="'Importe de bolsa solicitada'" [isRequired]="false">
                  <input class="form-control mb-1" autocomplete="off" type="text" name="RequestedAmount"
                    [(ngModel)]="requestedAmount" readonly>
                </app-form-input-app>

                <app-form-input-app [labelText]="'Importe de bolsa actual'" [isRequired]="false">
                  <input class="form-control mb-1" autocomplete="off" type="text" name="CurrentRealAmount"
                    [(ngModel)]="currentRealAmount" readonly>
                </app-form-input-app>

              </div>
            </div>


            <div class="col-6 ">
              <div class="block">
                <app-form-input-app [labelText]="'Importe de bolsa en el momento de la solicitud'" [isRequired]="false">
                  <input class="form-control mb-1" autocomplete="off" type="text" name="CurrentAmount"
                    [(ngModel)]="currentAmount" readonly>
                </app-form-input-app>

                <app-form-input-app [labelText]="'Solicitud de bolsa'" [isRequired]="false">
                  <input class="form-control mb-1" autocomplete="off" type="text" name="HolidayBagStateName"
                    [(ngModel)]="holidayBagState.name" readonly>
                </app-form-input-app>

              </div>
            </div>

          </div>
        </div>
      </div>


      <div class="row">
        <div class="col-sm-12 col-lg-12 ">
          <div class="row justify-content-center">

            <div *ngIf="holidayBagState.requestState1 == 0" class="button-container accept-deny">

              <div *ngIf="showHolidayBagAccepted">
                <h4 ngClass="approved">APROBADA</h4>
              </div>
              <div *ngIf="showHolidayBagRejected">
                <h4 ngClass="denied">RECHAZADA</h4>
              </div>

              <div *ngIf="enabledHolidayBagValidator && !showHolidayBagAccepted && !showHolidayBagRejected ">
                <button mat-raised-button class="rechazar-button"
                  [class.disabled-button]="hrState == 0 ? ((holidayBagState.requestState1 != 0) || !showAccepted) : false"
                  (click)="(holidayBagState.requestState1 == 0) && rejectHolidayBagRequest()">RECHAZAR</button>

                <button mat-raised-button class="aceptar-button"
                  [class.disabled-button]="hrState == 0 ? ((holidayBagState.requestState1 != 0) || !showAccepted) : false"
                  (click)="(holidayBagState.requestState1 == 0) && acceptHolidayBagRequest()">APROBAR</button>
              </div>
            </div>
          </div>
        </div>
      </div>


    </app-generic-panel>


  </div>


  <div id="focusBottom" class="button-container mb-1">
    <button *ngIf="currentPage != 0 && data.length >= 2" mat-raised-button class="anterior-button"
      (click)="prevPage()">ANTERIOR</button>
    <span *ngIf="data.length >= 2" class="counter-text">{{currentPage + 1}} de {{data.length}}</span>
    <button *ngIf="currentPage != data.length -1" mat-raised-button class="siguiente-button"
      (click)="nextPage()">SIGUIENTE</button>
    <button *ngIf="currentPage == data.length -1" mat-raised-button class="siguiente-button"
      (click)="closePopUp()">FINALIZAR</button>
  </div>

</div>